import React from 'react';
import { ClickableTile } from 'carbon-components-react';
import { Add32 } from '@carbon/icons-react';
import { APP_URL } from 'types';
import { useHistory } from 'react-router-dom';

const NavTile: React.FC<{}> = () => {
  const history = useHistory();
  return (
    <div className="dashboard-component--nav">
      <ClickableTile
        className="lodge-new-enquiry-tile"
        handleClick={() => history.push(APP_URL.LODGE_NEW_ENQUIRY)}
      >
        <div className="label">Lodge new enquiry</div>
        <Add32 />
      </ClickableTile>
    </div>
  );
};

export default React.memo(NavTile);
